module.exports = __webpack_public_path__ + "static/media/mercury.7166a75e.svg";